import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { MotionEffectsInitCallbackFactory } from '../motionEffectsInitCallbackFactory'
import { MotionEffects as EditorMotionEffects } from './editorMotionEffectsFactory'
import { MotionEffectsInitCallbackSymbol, MotionEffectsAPISymbol, MotionEffectsInitSymbol } from '../symbols'
import { MotionEffectsAPIFactory } from './motionEffectsAPI'

export const editor: ContainerModuleLoader = (bind) => {
	bind(MotionEffectsAPISymbol).to(MotionEffectsAPIFactory)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(MotionEffectsInitCallbackSymbol).to(MotionEffectsInitCallbackFactory)
	bind(LifeCycle.PageWillUnmountHandler, LifeCycle.PageWillMountHandler, MotionEffectsInitSymbol).to(
		EditorMotionEffects
	)
}
